import React, { Component } from 'react';
import { FormField, TextFieldLabel, Label, ErrorMessage } from '../../../styles/style';
import hazard from '../../../images/hazard-red.png';

class TextField extends Component {
  render() {
    let { label, value, name, disabled, short, update, onFocus, errorMessage, required, type, count, max, prepend, autoComplete, containerStyles, containerClass, onKeyPress } = this.props;

    return (
      <div style={containerStyles} className={containerClass}>
        {label && (
          <TextFieldLabel>
            <Label required={required} htmlFor={name}>{label}</Label>
            {errorMessage && (<ErrorMessage>{errorMessage[name]}</ErrorMessage>)}
          </TextFieldLabel>
        )}

        <div className={prepend && ("prepended")}>
          {prepend && (<span>{prepend}</span>)}
          <FormField
            value={value === null ? '' : value}
            type={type}
            id={name}
            name={name}
            style={(short ? {width: '50%'} : {})}
            onChange={update}
            onFocus={onFocus}
            onKeyPress={onKeyPress}
            disabled={disabled}
            prepend={prepend}
            autoComplete={autoComplete}
            className={value && max && (value.length > max) ? 'exceeded' : ''} />
            {count && max && (<p style={{margin: '10px 0 0 20px'}}>{value ? value.length : 0}/{max} characters {value && (value.length > max) ? (<img className="hazard" src={hazard} />) : ''}</p>)}
        </div>
      </div>
    )
  }
}

export default TextField;
